const eachRow = {
  system_config_no: '',
  group_no: '',
  type: '',
  address: ''
}

function convertGroupTable (groupConfigEntireData) {
  const tableData = []
  groupConfigEntireData.forEach((systemConfig, sysConfNum) => {
    systemConfig.forEach((groupConfig) => {
      if (groupConfig.Refrigerant.length > 0) {
        groupConfig.Refrigerant.forEach(refrigerant => {
          const row = JSON.parse(JSON.stringify(eachRow))
          row.system_config_no = sysConfNum + 1
          row.group_no = groupConfig.No
          row.type = '冷媒系'
          row.address = refrigerant
          tableData.push(row)
        })
      }
      if (groupConfig.Controller.length > 0) {
        groupConfig.Controller.forEach(controller => {
          const row = JSON.parse(JSON.stringify(eachRow))
          row.system_config_no = sysConfNum + 1
          row.group_no = groupConfig.No
          row.type = 'コントローラー系'
          row.address = controller
          tableData.push(row)
        })
      }
    })
  })
  return tableData
}
module.exports = convertGroupTable
